import { Component, Inject, Input, NgZone, OnInit } from '@angular/core';
import { Item, ItemService } from '../../item-detail/item-detail.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { GridComponent } from './grid/grid.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ProductCardComponent } from './grid/product-card/product-card.component';
import { MatIconModule } from '@angular/material/icon';
import { ProdCardComponent } from '../prod-card/prod-card.component';


@Component({
  selector: 'app-product-grid1',
  standalone: true,
  imports: [CommonModule,MatIconModule,RouterModule,ProdCardComponent],
  templateUrl: './product-grid1.component.html',
  styleUrl: './product-grid1.component.scss'
})
export class ProductGrid1Component implements OnInit{
  @Input()
  filteredItems: Item[] = [];
  @Input()
  isSS=false

  constructor(
    private itemService:ItemService,@Inject(DOCUMENT) private document: Document,
    private ngZone:NgZone,
    private route: ActivatedRoute){
      this.filteredItems=[]

  }
  ngOnInit(): void {

  }


  playAudio(): void {
    // const audio = new Audio();
    // audio.src = '../../../../assets/branding/tap2.mp3';
    // audio.volume=.10;
    // audio.load();
    // audio.play();

    this.ngZone.runOutsideAngular(() => {
      this.document.createElement('button').click()

      const audio = new Audio();
      audio.src = '../../../../assets/branding/tap2.mp3';
      // audio.volume=.10;
      audio.load();
      audio.play();
    })

  }

}
